<script lang="ts">
  import type { Snippet } from 'svelte';

  // Typed `any` deliberately — lucide-svelte icon components carry a wider
  // prop surface (color/strokeWidth/class/...) than TS's structural
  // Component<T> check tolerates for a narrowed `{ size }` prop type here.
  const {
    icon: Icon,
    heading,
    sub,
    action
  }: { icon: any; heading: string; sub?: string; action?: Snippet } = $props();
</script>

<div class="empty">
  <div class="ei"><Icon size={26} /></div>
  <div class="eh">{heading}</div>
  {#if sub}<div class="es">{sub}</div>{/if}
  {#if action}{@render action()}{/if}
</div>
